import { render, staticRenderFns } from "./OtherResources.vue?vue&type=template&id=0f1fcac8&"
import script from "./OtherResources.vue?vue&type=script&lang=js&"
export * from "./OtherResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports